import { StreetByCountryIAddressDTO } from 'src/app/shared/interfaces/addresses/dtos/street-by-country-dto.interface';
import { StreetsByCountryDTO } from 'src/app/shared/interfaces/contacts/dtos/streets-by-country-dto.interface';

export class StreetsByCountry {
  id: number | string;
  codePostal: string;
  codeRue: string;
  codeLangue: string;
  rueNom: string;
  isFromAnotherAPI: boolean;

  constructor(
    data: StreetsByCountryDTO | StreetByCountryIAddressDTO,
    fromApp: 'fromiContact' | 'fromiAddress',
    isFromAnotherAPI: boolean,
    codeLangContact?: string
  ) {
    if (fromApp === 'fromiContact') {
      Object.assign(this, data);
    } else {
      const dataIAddress = data as StreetByCountryIAddressDTO;
      this.id = dataIAddress.id;
      this.codePostal = dataIAddress.postalCode;
      this.codeRue = dataIAddress.streetCode;
      this.codeLangue = codeLangContact ?? 'FR';

      const langMap = {
        FR: dataIAddress.nameFr,
        NL: dataIAddress.nameNl,
        DE: dataIAddress.nameDe,
      };

      this.rueNom =
        langMap[codeLangContact] ||
        (dataIAddress.nameFr ? dataIAddress.nameFr : dataIAddress.nameNl ? dataIAddress.nameNl : dataIAddress.nameDe ? dataIAddress.nameDe : '');
    }
    this.isFromAnotherAPI = isFromAnotherAPI;
  }
}

export class ManagementStreetsParams {
  codePostal: string;
  codeRue: string;
  codeLangue: string;
  rue: string;
  externalApiSourceId: string;

  constructor(data?) {
    Object.assign(this, data);
  }
}
